import { render, staticRenderFns } from "./VerifyChip.html?vue&type=template&id=bcfc80c6&scoped=true&"
import script from "./VerifyChip.js?vue&type=script&lang=js&"
export * from "./VerifyChip.js?vue&type=script&lang=js&"
import style0 from "./VerifyChip.scss?vue&type=style&index=0&id=bcfc80c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfc80c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
